
/**
 * @export
 * @enum {string}
 */
export enum CredentialsType {
    PASSWORD = 'PASSWORD',
    OAUTH = 'OAUTH'
}